<script lang="ts" setup>
import MateProfile from "@/components/mobile/MateProfile.vue";
// import MateStoryBookList from "@/components/mobile/story/story-book/MateStoryBookList.vue";
import { useMate } from "@/stores/mate";
import { showSuccessToast } from "vant";
import { computed, nextTick, onActivated, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import i18n from "@/locales";
import { copyToClipboard } from "@/modules/common";
import { useGlobalUser } from "@/stores/globalUser";
import { Mate, MateLink } from "@/types/entity";
import MateHomeMateCard from "./MateHomeMateCard.vue";
import { useModule } from "@/stores/module";
import { useAdmire } from "@/stores/admire";
import { MateAdoptionStatus } from "@/enums/mateEnums";
import { AxiosError } from "axios";

// import { ApiGetGalGamePage } from "@/apis/gal-game";
// import { useGalGameHome } from "@/stores/galGameHome";
// import CollectionList from "@/views/Collection/components/CollectionList.vue";

const routeNames = ["mateHome", "myMate"];
const route = useRoute();
const router = useRouter();
const mateStore = useMate();
// const gameHomeStore = useGalGameHome();
const userStore = useGlobalUser();
const mate = ref<Mate | null>(null);
// const isMyMate = computed(
//   () =>
//     route.name === "myMate" || mateUuid.value === mateStore.currentMate?.uuid
// );
const isLoading = ref(false);
const isShareShow = ref(false);
const moduleStore = useModule();
const mateUuid = ref<string>("");
const scrollableEl = ref<HTMLElement | null>(null);
const scrollState = {
  moment: 0,
  profile: 0,
  collection: 0,
  gallery: 0,
  story: 0,
  game: 0,
};
type ScrollState = keyof typeof scrollState;
// LifeCycle
const hasProfileAuth = ref(false);
const prepareData = async (uuid?: string) => {
  if (!routeNames.includes(route.name as string)) return;
  isLoading.value = true;
  if (!uuid) uuid = mateUuid.value;
  mateStore.mateHomeTab = "profile";
  try {
    const _mate = await mateStore.getOrFetchMate(uuid);

    if (mateStore.isMyMate(uuid) || _mate.visibility === 1) {
      hasProfileAuth.value = true;
    } else if (_mate.visibility === 4 && useGlobalUser().isLogin) {
      // 检查是不是好友

      // const admireRecord = await useAdmire().admire(currentMate.value!.id!);
      const admireRecord = await useAdmire().isAdmiring(
        // mateStore.userMate!.id!
        _mate.user.userMate!.id
      );
      if (admireRecord && admireRecord.status === undefined) {
        // 是好友
        hasProfileAuth.value = true;
      }
    }

    if (!hasProfileAuth.value && _mate.interactionPool) {
      hasProfileAuth.value = true;
    }

    if (hasProfileAuth.value) {
      await moduleStore.initModule(uuid, "mate");
    }

    isLoading.value = false;
    if (_mate.uuid !== uuid) return false;
    mate.value = _mate;

    if (route.query.isTreehole) {
      mateLink.value = _mate.mateLink;
    }

    // fetchMateGame();
    return true;
  } catch (e: unknown) {
    // 未找到Mate
    const error = e as AxiosError<{ message?: string }>;
    isLoading.value = false;
    if (
      ["Mate 未找到", "Mate not found"].includes(
        error.response?.data?.message ?? ""
      )
    ) {
      if (!userStore.isLogin) return router.push({ name: "login" });
    }
  }
};

// const gameList = ref<GalGame[]>([]);

// const fetchMateGame = async () => {
//   if (isMyMate.value) return gameHomeStore.initCreate();
//   const { page } = await ApiGetGalGamePage({ mateId: mate.value?.id });
//   gameList.value = page.data;
//   return mate;
// };

const mateLink = ref<MateLink | null>();

onMounted(() => {
  if (route.params.uuid?.toString()) {
    mateUuid.value = route.params.uuid.toString();
  } else if (route.name === "myMate") {
    mateUuid.value = mateStore.currentMate?.uuid ?? "";
  }
  prepareData();
});

onActivated(() => {
  recoverScrollState(scrollState[mateStore.mateHomeTab as ScrollState]);
});
// Event Handler

const saveScrollState = () => {
  if (!scrollableEl.value) return;
  scrollState[mateStore.mateHomeTab as ScrollState] =
    scrollableEl.value.scrollTop;
};

const recoverScrollState = (originHeight = 0) => {
  nextTick(() => {
    scrollableEl.value!.scrollTop = originHeight;
  });
};

const updateTab = (tab: ScrollState) => {
  if (scrollState[tab] === 0) {
    scrollState[tab] = Math.min(
      scrollState[mateStore.mateHomeTab as ScrollState],
      640
    );
  }
  mateStore.mateHomeTab = tab;
  recoverScrollState(scrollState[tab]);
};

// popup;
const profileUrl = computed(() => window.location.href);
const onCopy = async () => {
  copyToClipboard(window.location.href);
  showSuccessToast(i18n.global.t("Message.copySuccessful"));
};
</script>
<template>
  <div
    :class="[
      'h-full grid',
      route.name === 'myMate' ? ' grid-rows-[1fr]' : ' grid-rows-[auto_1fr]',
    ]"
  >
    <threads-nav :show-center="false" show-back>
      <template #right>
        <div
          v-if="mateStore.isMyMate(mate?.uuid || '') && mate?.status === 0"
          class="flex items-center gap-2"
        >
          <button
            class="btn btn-sm btn-primary"
            @click="mateStore.publish(mate!.uuid)"
          >
            {{ $t("Buttons.publish") }}
          </button>
        </div>
        <CrystalPowerCount
          v-else-if="
            userStore.isLogin &&
            mate?.adoptionStatus === MateAdoptionStatus.Available &&
            !mateStore.isMyMate(mate!.uuid)
          "
        />
        <div v-else class="flex items-center gap-2">
          <button class="btn btn-sm btn-outline" @click="onCopy">
            <i class="iconify mdi--share-outline"></i>
            <span>{{ $t("share.name") }}</span>
          </button>
        </div>
      </template>
    </threads-nav>
    <div
      ref="scrollableEl"
      class="overflow-y-scroll relative"
      @scroll="saveScrollState"
    >
      <div
        v-if="isLoading"
        class="w-full h-full flex items-center justify-center"
      >
        <span class="loading loading-ring"></span>
      </div>
      <div v-else-if="mate" class="h-full flex flex-col">
        <div class="h-fit">
          <MateHomeMateCard :mate="mate" class="rounded-none shadow-none" />
        </div>
        <!-- 内容区 -->
        <div class="flex-grow">
          <VanTabs
            v-if="!route.query.isTreehole"
            :active="mateStore.mateHomeTab"
            :offset-top="route.name !== 'myMate' ? 56 : 0"
            class="h-full thread-tabs"
            sticky
            swipeable
            @update:active="updateTab"
          >
            <VanTab
              :title="i18n.global.t('SidebarNavi.profile')"
              name="profile"
            >
              <mate-profile
                v-if="moduleStore.module || !hasProfileAuth"
                :basic-info="mate!"
                :mate="mate!"
                :has-profile-auth="hasProfileAuth"
              />
            </VanTab>

            <VanTab
              :title="i18n.global.t('SidebarNavi.timeline')"
              name="timeline"
            >
              <TimelineModule
                :entity-id="mate!.id!"
                :entity-uuid="mate.uuid"
                :universe-id="mate.universeId"
                entity-type="mate"
                class="px-2 pb-2"
                :enable-edit="false"
              />
            </VanTab>
            <VanTab :title="i18n.global.t('collection.moment')" name="moment">
              <MomentModule :mate="mate!" :show-create="false" />
            </VanTab>
            <VanTab
              v-if="mate.adoptionStatus === MateAdoptionStatus.Available"
              :title="i18n.global.t('User.mate.module.gallery')"
              name="gallery"
            >
              <MateGallery
                class="p-2"
                :mate-id="mate.id!"
                :vertical-expand="false"
              />
            </VanTab>
            <VanTab
              v-if="userStore.isLogin"
              name="roleplay"
              :title="i18n.global.t('User.mate.module.roleplay')"
            >
              <RoleplayModule :mate="mate!" />
            </VanTab>
            <!-- <tab :title="i18n.global.t('MineMate.story')" name="story">
              <template v-if="isMyMate">
                <div class="p-4 grid grid-cols-2 gap-3 overflow-y-auto">
                  <story-book-list-item1
                    v-for="item in storyBookStore.allStoryBookList"
                    :key="item.id"
                    :story-book="item"
                    show-draft
                    @click="
                      $router.push({
                        name: 'storyBookHome',
                        params: { uuid: item.uuid },
                      })
                    "
                  />
                </div>
              </template>
              <mate-story-book-list v-else :mate-id="mate!.id" hide-tab />
            </tab> -->
            <!-- <tab :title="i18n.global.t('collection.name')" name="collection">
              <div class="pb-2">
                <CollectionList :mateId="mate.id!" edit :show-create="false" />
              </div>
            </tab> -->
            <!-- <tab :title="i18n.global.t('SidebarNavi.gallery')" name="gallery">
              <mate-gallery1
                :mate="mate"
                :mate-id="mate?.id"
                :scroller="scrollableEl"
                class="p-2"
              />
            </tab> -->

            <!-- <tab :title="i18n.global.t('MineMate.game')" name="game">
              <div class="p-4">
                <div
                  v-if="
                    (!isMyMate && gameList.length === 0) ||
                    (isMyMate &&
                      gameHomeStore.create[2].length +
                        gameHomeStore.create[1].length ===
                        0)
                  "
                  class="h-40 flex flex-col items-center justify-center"
                >
                  <div class="text-2xl font-bold text-base-content/50">
                    {{ $t("Message.noGamesYet") }}
                  </div>
                  <div class="text-base-content/50">
                    {{ $t("Message.noGamesYetDesc") }}
                  </div>
                </div>
                <ItemGalGameHome
                  v-for="game in [
                    ...gameHomeStore.create[2],
                    ...gameHomeStore.create[1],
                  ]"
                  v-else-if="isMyMate"
                  :key="game"
                  :game="gameHomeStore.gameMap[game]"
                  mode="edit"
                />
                <ItemGalGameHome
                  v-for="game in gameList"
                  v-else
                  :key="game.uuid"
                  :game="game"
                />
              </div>
            </tab> -->
          </VanTabs>
          <div v-else>
            <mate-profile
              :basic-info="mate!"
              :mate="mate!"
              :has-profile-auth="hasProfileAuth"
            />
          </div>
        </div>
      </div>
    </div>
    <VanPopup
      v-model:show="isShareShow"
      :closeable="true"
      class="p-4"
      position="center"
      round
    >
      <div class="font-bold text-base">{{ $t("share.name") }}</div>
      <div class="divider">{{ $t("share.shareWithLink") }}</div>
      <div
        class="text-base-content/50 bg-neutral rounded flex gap-2 items-center p-2"
      >
        <div class="flex">{{ profileUrl }}</div>
        <button class="shrink-0 btn btn-sm btn-ghost" @click="onCopy">
          <i class="iconfont icon-copy" />
        </button>
      </div>
    </VanPopup>
  </div>
</template>
<style>
.gallery-uploader .van-uploader__input-wrapper {
  width: 100%;
}

.gallery-uploader .van-uploader__wrapper {
  @apply flex gap-0;
}
</style>
